var map = {
	"./begrippen.js": 183,
	"./bekendePersonen.js": 184,
	"./bners.js": 185,
	"./dieren.js": 186,
	"./drankEnDrugs.js": 187,
	"./geografie.js": 188,
	"./geschiedenis.js": 189,
	"./media.js": 190,
	"./muziek.js": 191,
	"./sport.js": 192,
	"./sprookjes.js": 193,
	"./voeding.js": 194,
	"./wetenschap.js": 195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 182;